// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import {
  PencilSquareIcon,
  TrashIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import { useNavigate, Link } from "react-router-dom";
import { useGetUsersQuery, useDeleteUserMutation } from "./usersApiSlice";
import { memo, useState, useEffect } from "react";

import UserModal from "./UserModal";
import EditUserForm from "./EditUserForm";

const User = ({ userId, index }) => {
  //Modal
  // const [userId, setuserId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  const { user } = useGetUsersQuery("usersList", {
    selectFromResult: ({ data }) => ({
      user: data?.entities[userId], //Dobija jedan user object { id: "f6ae3dfa34edf", name: "Vanja"... }
    }),
  });

  // console.log(user);

  //Napravi fetch da salje user id

  const [
    deleteUser,
    { isSuccess: isDelSuccess, isError: isDelError, error: delerror },
  ] = useDeleteUserMutation();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  //MOdal edit
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);

  //Server error
  useEffect(() => {
    if (isDelError) {
      alert(delerror.data.message);
    }
    // console.log("user", user);
  });

  const handleConfirm = async () => {
    await deleteUser({ id: user.id });
    closeModal();
  };

  //ZA edit zaposlenog
  const handleOpenModalEdit = () => {
    setIsModalOpenEdit(true);
    // setuserId(userId);
    //i da poslajem user id da bi nasao objekat iz kesha koji ce da modifikuje
  };

  const handleCloseModalEdit = () => {
    setIsModalOpenEdit(false);
  };

  const handleFormSubmitEdit = () => {
    handleCloseModalEdit();
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB").replace(/\//g, "/"); // YYYY/MM/DD
  }

  function calculateAge(birthDateString) {
    const birthDate = new Date(birthDateString);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  }

  if (user) {
    const userProfile = () => navigate(`/dash/users/${userId}`);

    //const userRolesString = user.roles.toString().replaceAll(",", ", ");

    return (
      <>
        {/* <tr key={userId}>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {index + 1}.
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
            <Link
              to={`/dash/users/${userId}`}
              className="text-blue-600 hover:text-blue-800"
            >
              {user.name}
            </Link>
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user.lastName}
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user.mail}
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user.pol}
          </td>
          <td
            className="border-b border-r px-4 py-2 text-sm text-gray-700"
            title={user?.komentar}
          >
            {user?.komentar?.length > 30
              ? user?.komentar.substring(0, 30) + "..."
              : user?.komentar}
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user.lastActivePackage ? (
              `${user.lastActivePackage.naziv_paketa} - ${formatDate(
                user.lastActivePackage.datum_placanja
              )}`
            ) : (
              <span className="text-red-600 font-bold">Nema paket</span>
            )}
          </td>

          <td className="border-b px-4 py-2 text-sm">
            <button
              onClick={openModal}
              className="text-red-600 hover:text-red-800 mr-2"
            >
              <TrashIcon className="h-5 w-5" aria-hidden="true" />
            </button>
            <button
              onClick={userProfile}
              className="text-blue-600 hover:text-blue-800"
            >
              <UserIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </td>
        </tr> */}

        {/* "googleId": "108922231299248954811",
        "isVerifiedGoogle": true, */}

        <tr key={userId}>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {index + 1}.
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700 flex items-center gap-2">
            {user.googleId ? (
              <>
                <img
                  src={`${process.env.PUBLIC_URL}/img/g2.png`}
                  alt="Google korisnik"
                  className="w-6 h-6 object-contain"
                />
                {/* {user.googleId} */}
              </>
            ) : (
              <>
                <img
                  src={`${process.env.PUBLIC_URL}/img/nutriLogo.png`}
                  alt="Nema Google ID"
                  className="w-6 h-6 object-contain"
                />
              </>
            )}
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
            <Link
              to={`/dash/users/${userId}`}
              className="text-blue-600 hover:text-blue-800"
            >
              {user.name}
            </Link>
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user.lastName}
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {/* {calculateAge(user.datumRodjenja)} */}
            {calculateAge(user.datumRodjenja)
              ? calculateAge(user.datumRodjenja)
              : "-"}
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user.tezina ? `${user.tezina} kg` : "-"}
          </td>

          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user.mail}
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user.pol}
          </td>
          <td
            className="border-b border-r px-4 py-2 text-sm text-gray-700"
            title={user?.komentar || "-"}
          >
            {user?.komentar?.length > 30
              ? user?.komentar.substring(0, 30) + "..."
              : user?.komentar || "-"}
          </td>
          <td
            className={`border-b border-r px-4 py-2 text-sm text-gray-700 ${
              user.datumRegistracije == "" ? "bg-red-500" : "bg-green-500"
            }`}
          >
            {user.datumRegistracije}
          </td>

          {/* <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user.lastActivePackage ? (
              `${user.lastActivePackage.naziv_paketa} - ${formatDate(
                user.lastActivePackage.datum_placanja
              )} - ${
                user.lastActivePackage.tip === "Mesečno"
                  ? "M"
                  : user.lastActivePackage.tip === "Godišnje"
                  ? "G"
                  : user.lastActivePackage.tip === "Starter"
                  ? "S"
                  : user.lastActivePackage.tip
              } - ${user.lastActivePackage.broj.full}`
            ) : (
              <span className="text-red-600 font-bold">Nema paket</span>
            )}
          </td> */}

          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user?.lastActivePackage?.naziv_paketa}
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user?.lastActivePackage?.tip === "Mesečno"
              ? "M"
              : user?.lastActivePackage?.tip === "Godišnje"
              ? "G"
              : "J"}
          </td>

          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {formatDate(user?.lastActivePackage?.datum_placanja)}
          </td>
          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user?.lastActivePackage?.broj.full}
          </td>

          <td className="border-b border-r px-4 py-2 text-sm text-gray-700">
            {user.usedCodes.length === 0 ? (
              <span className="text-red-600 font-bold">-</span>
            ) : (
              `${user.usedCodes[0].naziv}`
            )}
          </td>

          <td className="border-b px-4 py-2 text-sm">
            {user.name == "Admin" ? (
              <></>
            ) : (
              <button
                onClick={openModal}
                className="text-red-600 hover:text-red-800 mr-2"
              >
                <TrashIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            )}

            <button
              onClick={userProfile}
              className="text-blue-600 hover:text-blue-800"
            >
              <UserIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </td>
        </tr>

        <UserModal isOpen={isModalOpenEdit} onClose={handleCloseModalEdit}>
          <EditUserForm
            onSubmit={handleFormSubmitEdit}
            onClose={handleCloseModalEdit}
            userId={userId}
          />
        </UserModal>

        {isModalOpen && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
            <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
              <div className="mt-3 text-center">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                  <svg
                    className="h-6 w-6 text-yellow-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    />
                  </svg>
                </div>
                <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                  Upoznorenje
                </h3>
                <div className="mt-2 px-7 py-3">
                  <p className="text-sm text-gray-500">
                    Da li ste sigurni da želite izbrisati odbaranog klijenta
                  </p>
                </div>
                <div className="items-center px-4 py-3">
                  <button
                    onClick={handleConfirm}
                    className="px-4 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                  >
                    Da
                  </button>
                  <button
                    onClick={closeModal}
                    className="mt-3 px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                  >
                    Ne
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  } else return null;
};

const memoizedUser = memo(User);

export default memoizedUser;

// Ikonice ravnomerno rasporednjene
{
  /* <td className="flex justify-between relative whitespace-nowrap p-4 text-sm font-medium sm:pr-6">
    <button href="#" onClick={handleEdit} className="text-blue-600 hover:text-blue-900">
        <PencilSquareIcon className="h-5 w-5 shrink-0" aria-hidden="true"/>
    </button>
    <button href="#" onClick={handleEdit} className="text-blue-600 hover:text-blue-900">
        <PencilSquareIcon className="h-5 w-5 shrink-0" aria-hidden="true"/>
    </button>
    <button href="#" onClick={openModal} className="text-blue-600 hover:text-blue-900">
        <TrashIcon className="h-5 w-5 shrink-0 stroke-red-600" aria-hidden="true"/>
    </button>
</td> */
}

{
  /* <th
scope="col"
className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
>
Paket
</th>
<th
scope="col"
className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
>
Tip
</th>
<th
scope="col"
className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
>
Datum
</th>
<th
scope="col"
className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
>
Preostalo
</th> */
}
